import { z } from 'zod';

export const toggleDividendsReinvestGetResponseSchema = z.object({
  data: z.object({ value: z.number().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
